var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.videoItem.videoSrc ? _c('div', {
    staticClass: "video-player-container",
    class: _vm.containerClass
  }, [!_vm.videoItem.isVideoUnavailable ? _c('EmbeddedVideoPlayer', {
    attrs: {
      "videoId": `video-player-id-${_vm.videoItem.videoNum}`,
      "videoSource": _vm.videoItem.videoSrc,
      "selectedVideoId": _vm.selectedVideoId
    },
    on: {
      "video-player-in-progress": _vm.isVideoPlayerPlayer
    }
  }) : _c('div', {
    staticClass: "video-unavailability mt-4 mt-md-0 mt-lg-0 mt-xl-0"
  }, [_c('span', [_vm._v(" This video is being updated ")])])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }